import SkeletonLoading from "../../../../Components/Skeleton/SkeletonLoading";
import VerifyEmail from "../../../Authentication/Components/VerifyEmail";
import SVG from "react-inlinesvg";

type Props = {
    email: string;
    isEmailVerified: boolean;
    setIsEmailVerified: (value: boolean) => void;
    isLoading: boolean;
    steIsLoading: (vlaue: boolean) => void;
    sendVerificationCode: (email: string) => void;
    handleVerifyCode: (code: string) => void;
}

const ConfirmParentEmail: React.FC<Props> = ({ email, isLoading, isEmailVerified, steIsLoading, setIsEmailVerified, sendVerificationCode, handleVerifyCode }) => {

    const resendVerificationCode = () => {
        sendVerificationCode(email);
    }

    const onSubmitOTP = (otp: any) => {
        handleVerifyCode(otp);
    }
    return (
        <>
            <div className="main-wrapper confirm-order-screens">
                <div className="cards-wrap card-success">
                    <div className="card-body confirm-order-model">
                        <div className="header w-100 justify-content-center">
                            <div className="logo mb-4">
                                {" "}
                                <SVG
                                    className="header-logo"
                                    src="Assets/Images/Logos/kiddo.svg"
                                    width="108"
                                    height="32"
                                />{" "}
                            </div>
                            <div className="text-center">
                                <h1 className="title-medium text-center theme-color fs-5 mb-3">
                                    {isLoading && !isEmailVerified ? (<SkeletonLoading width={230} height={33} />) : ("Please verify your email") }
                                </h1>
                                <p className="header-text mb-5">
                                    {isLoading && !isEmailVerified ? (<SkeletonLoading width={240} height={21} />) : (<>Verification code has been sent to <br /> {email}</>)}
                                </p>
                            </div>
                        </div>
                        <div className="card-inner confirm-order">
                            <VerifyEmail
                                onResendOTP={resendVerificationCode}
                                onSubmitOTP={onSubmitOTP}
                                isInitialSendCode={true}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmParentEmail;